/* eslint-disable no-useless-escape */
import { Validation, ValidationStatus, ValidationInputFn, IInputConfig } from "./types";

export function getFormItemCss(item, validate?: boolean, focus = false) {
	const { labelPosition, required, disabled, hiddenLabel, $validationStatus } = item;
	const cssStatus =
		{
			[ValidationStatus.pre]: "",
			[ValidationStatus.error]: " dhx_form-group--state_error",
			[ValidationStatus.success]: " dhx_form-group--state_success",
		}[$validationStatus] || "";
	const labelPositionCss = labelPosition === "left" ? " dhx_form-group--inline" : "";
	const requiredCss = required ? " dhx_form-group--required" : "";
	const disabledCss = disabled ? " dhx_form-group--disabled" : "";
	const labelSrCss = hiddenLabel ? " dhx_form-group--label_sr" : "";
	const focusStatus = focus ? "" : cssStatus;

	if (validate) {
		return labelPositionCss + focusStatus + requiredCss + disabledCss + labelSrCss;
	}
	return labelPositionCss + disabledCss + labelSrCss;
}

const validators: { [key: string]: RegExp } = {
	[Validation.validAlphaNumeric]: /^[a-zA-Z0-9_]+$/,
	[Validation.validEmail]: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	[Validation.validInteger]: /^-?\d+$/,
	[Validation.validIPv4]: /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/,
	[Validation.validNumeric]: /^-?\d+(\.\d+)?$/,
};

export function getValidationMessage(item) {
	const validationMessage =
		{
			undefined: item.preMessage,
			[ValidationStatus.pre]: item.preMessage,
			[ValidationStatus.error]: item.errorMessage,
			[ValidationStatus.success]: item.successMessage,
		}[item.$validationStatus] || "";
	return validationMessage;
}

export function validateTemplate(template: Validation, str) {
	return validators[template] ? validators[template].test(str) : true;
}

export function isBlock(config): any {
	return Boolean(config.rows) || Boolean(config.cols);
}

export function validateInput(value: string | number, validation: Validation | ValidationInputFn): boolean {
	let isValid = true;
	if (typeof validation === "function") {
		isValid = validation(value);
	} else {
		const regExp = validators[validation];
		if (regExp) {
			isValid = regExp.test(value.toString());
		}
	}

	return isValid;
}

export function baseInputValidate(value: string | number, config: IInputConfig): boolean {
	const { inputType, min, max, minlength, maxlength } = config;
	if (inputType === "number") {
		if (typeof min !== "undefined" && typeof max !== "undefined") {
			return Number(min) <= Number(max) && Number(min) <= Number(value) && Number(max) >= Number(value);
		} else if (typeof min !== "undefined") {
			return Number(min) <= Number(value);
		} else if (typeof max !== "undefined") {
			return Number(max) >= Number(value);
		} else {
			return value === 0 || value === "0" || !!value;
		}
	} else {
		if (typeof minlength !== "undefined" && typeof maxlength !== "undefined") {
			return Number(minlength) <= String(value).length && Number(maxlength) >= String(value).length;
		} else if (typeof minlength !== "undefined") {
			return Number(minlength) <= String(value).length;
		} else if (typeof maxlength !== "undefined") {
			return Number(maxlength) >= String(value).length;
		} else {
			return typeof value === "string" && !!value;
		}
	}
}

export function isTimeFormat(value: string, timeFormat?: number): boolean {
	if (timeFormat === 12) {
		return /(^0?([1-9][0-2]?):[0-5][0-9]?([AP][M]?)$)/i.test(value);
	}
	return /(^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$)/i.test(value);
}

export function isVerify(config): boolean {
	const validationProp: string[] = ["required", "validation", "minlength", "maxlength", "min", "max"];
	return validationProp.some(prop => {
		switch (prop) {
			case "required":
				return !!config[prop];
			case "validation":
				return (
					typeof config[prop] === "function" ||
					config[prop] === "email" ||
					config[prop] === "integer" ||
					config[prop] === "numeric" ||
					config[prop] === "alphanumeric" ||
					config[prop] === "IPv4"
				);
			case "minlength":
			case "maxlength":
				return typeof config[prop] === "number" || typeof config[prop] === "string";
			case "min":
			case "max":
				return (
					(typeof config[prop] === "number" || typeof config[prop] === "string") &&
					config.inputType === "number"
				);
		}
	});
}

export const baseProps = ["width", "height", "padding", "css"];

export const widgetConfig = ({
	width,
	type,
	id,
	name,
	hidden,
	editable,
	valueFormat,
	css,
	required,
	helpMessage,
	preMessage,
	successMessage,
	errorMessage,
	label,
	labelWidth,
	labelPosition,
	hiddenLabel,
	validation,
	icon,
	...res
}: any): any => res;
